const logEvent = (eventName, eventData = null) => {
	try {
		let cleverTap = window.clevertap;
		eventData.origin_source = "OMS";
		cleverTap.event.push(eventName, eventData);
	} catch (error) {
		console.log(error);
	}
};

const onUserLogin = (name, omsid, phone = "", data = {}) => {
	try {
		let cleverTap = window.clevertap;
		cleverTap.onUserLogin.push({
			Site: {
				Name: name,
				Identity: omsid,
				...(phone && { Phone: phone }),
				data,
			},
		});
	} catch (error) {
		console.log(error);
	}
};

export const ClevertapAnalytics = {
	logEvent,
	onUserLogin,
};
